import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UiState {
  isExporting: boolean;
  showScrollTop: boolean;
  selectedRows: number[];
}

const initialState: UiState = {
  isExporting: false,
  showScrollTop: false,
  selectedRows: [],
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setIsExporting: (state, action: PayloadAction<boolean>) => {
      state.isExporting = action.payload;
    },
    setShowScrollTop: (state, action: PayloadAction<boolean>) => {
      state.showScrollTop = action.payload;
    },
    setSelectedRows: (state, action: PayloadAction<number[]>) => {
      state.selectedRows = action.payload;
    },
  },
});

export const { setIsExporting, setShowScrollTop, setSelectedRows } =
  uiSlice.actions;
export default uiSlice.reducer;
